export default __webpack_public_path__ + "0f7bbc5ba366d55a3c23298ad07dfeed.svg";